import React from "react"

const FAQItem = ({ question, children }) =>
  <div itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
    <h3 itemProp="name">{question}</h3>
    <div itemScope itemProp="acceptedAnswer" itemType={"https://schema.org/Answer"}>
      <p itemProp="text">
        {children}
      </p>
    </div>
  </div>

export default FAQItem
